module.exports = __webpack_public_path__ + "static/media/icon-pin.322e7f3f.svg";